/** @jsxImportSource @emotion/react */
import * as React from 'react'

function DashboardScreen() {
  return (
    <></>
  )
}

export {DashboardScreen}
